export const blockIconsCommunicationRssFeed = (
	<span className='material-symbols-outlined'>rss_feed</span>
);
